/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React from 'react';

import {SortableHandle} from 'react-sortable-hoc';

import Switch from '@/components/switch/Switch';
import ToggleButtonCustom from '@/components/togglebutton/src/ToggleButtonCustom';
import * as APPDATA from '@/constants/pcConstAppData';
import {SEQUENCE_TYPE, RUN_TIME_MODE, SEQUENCE_TYPE_ALL_ENUM} from '@/constants/sequenceContentConstants';
import {consoleLog} from '@/libs/consoleHelper';

import {ConvertRepeatMode} from '../business/commonFunction';

import './Cycle.less';

const DragHandle = SortableHandle(() => (
  <div className="middleAlign grippyDiv">
    {' '}
    <span className="grippy" />
  </div>
));

const deleteSequence = 'deleteSequence';
const repeat = 'repeat';
const settingSequence = 'settingCycle';
const saveConfig = 'saveConfig';
const discardConfig = 'discardConfig';

class CycleSetting extends React.PureComponent {
  onClick = (e) => {
    const {sequence, removeSequence, onClickSequenceConfig, onClickSaveConfig, onClickDiscardConfig} = this.props;
    switch (e.currentTarget.id) {
      case deleteSequence:
        removeSequence(sequence.Id);
        break;
      case APPDATA.SEQUENCE:
        this.sequenceChange(sequence.Sequence);
        break;
      case repeat:
        break;
      case settingSequence:
        onClickSequenceConfig(sequence.Id);
        break;
      case saveConfig:
        onClickSaveConfig(sequence.Id);
        break;
      case discardConfig:
        onClickDiscardConfig(sequence.Id);
        break;
      default:
        break;
    }
  };

  handleChangeSequenceState = () => {
    const {sequence, updateSequenceState} = this.props;
    updateSequenceState(sequence.Id, !sequence.Active);
  };

  // handleChangePressureType = () => {
  //   const {sequence, updatePressureType} = this.props;
  //   let newValue;
  //   if (sequence.PressureState.PressureType === PRESSURE_TYPE.LO) newValue = PRESSURE_TYPE.HI;
  //   else if (sequence.PressureState.PressureType === PRESSURE_TYPE.HI) newValue = PRESSURE_TYPE.LO;
  //   else {
  //     newValue = PRESSURE_TYPE.LO;
  //     consoleError('Pressure type is undefined');
  //   }
  //   updatePressureType(sequence.Id, newValue);
  // };

  sequenceChange = (currentValue) => {
    const {sequence, sequenceChange} = this.props;
    sequenceChange(sequence.Id, currentValue);
  };

  updateRepeatSequence = () => {
    const {sequence, updateTotalRepeat} = this.props;
    updateTotalRepeat(sequence.Id);
  };

  // eslint-disable-next-line class-methods-use-this
  sequenceNameConverter = (sequence) => {
    consoleLog('sequenceNameConverter', sequence);
    switch (sequence) {
      case SEQUENCE_TYPE_ALL_ENUM.PRIME.BE:
        return SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.PRIME.FE].label;

      case SEQUENCE_TYPE_ALL_ENUM.PRIME_BY_SAMPLE.BE:
        return SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.PRIME_BY_SAMPLE.FE].label;

      case SEQUENCE_TYPE_ALL_ENUM.CONCENTRATE.BE:
        return SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.CONCENTRATE.FE].label;

      case SEQUENCE_TYPE_ALL_ENUM.AIR_RECOVERY.BE:
        return SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.AIR_RECOVERY.FE].label;

      case SEQUENCE_TYPE_ALL_ENUM.DIAFILTRATE.BE:
        return SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.DIAFILTRATE.FE].label;

      // case SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.REVERSE_DIAFILTRATE.value :
      //     return SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.REVERSE_DIAFILTRATE.label

      case SEQUENCE_TYPE_ALL_ENUM.BUFFER_RECOVERY.BE:
        return SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.BUFFER_RECOVERY.FE].label;

      // MIXING FEATURE F.A.W
      case SEQUENCE_TYPE_ALL_ENUM.TUBE_MIXING.BE:
        return SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.TUBE_MIXING.FE].label;

      // MIXING FEATURE F.A.W
      case SEQUENCE_TYPE_ALL_ENUM.RECIRCULATION.BE:
        return SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.RECIRCULATION.FE].label;

      default:
        return SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.PRIME.FE].label;
    }
  };

  handleChangeRepeatMode = (e) => {
    const {sequence} = this.props;
    let newValue = -1;
    switch (e.currentTarget.id) {
      case RUN_TIME_MODE.TIMES.NAME:
        newValue = RUN_TIME_MODE.TIMES.VALUE;
        break;
      case RUN_TIME_MODE.MINUTES.NAME:
        newValue = RUN_TIME_MODE.MINUTES.VALUE;
        break;
      default:
        break;
    }
    consoleLog('handleChangeRepeatMode', {sequence, RepeatType: sequence.RepeatType, newValue});
    if (sequence.RepeatType !== newValue) {
      ConvertRepeatMode(sequence);
      this.props.onChangeRepeatMode(sequence.Id, newValue);
    }
  };

  render() {
    const {sequence, isSequenceDesignerRunning, isConfigView} = this.props;
    const isRunning = sequence.Running && isSequenceDesignerRunning ? ' running blink_me' : '';
    const dissableEdit = !!isSequenceDesignerRunning;
    // const repeatedValue = sequence.Repeated === undefined ? 0 : sequence.Repeated;
    const repeatValue = sequence.TempRepeat === undefined ? sequence.Repeat : sequence.TempRepeat; // isSequenceDesignerRunning ?repeatedValue+" Of "+sequence.Repeat :  sequence.TempRepeat
    // const switchPressure = sequence === undefined ? false : sequence.PressureState.PressureType !== PRESSURE_TYPE.LO;
    // let disabledHIPressure = false;
    // for (const key in MANUAL_CONTROL_LOW_PRESSURE_ONLY) {
    //   if (MANUAL_CONTROL_LOW_PRESSURE_ONLY[key] === sequence.Sequence) {
    //     disabledHIPressure = true;
    //     break;
    //   }
    // }
    // const settingButton = {
    //   id: settingSequence,
    //   className: 'glyphicon glyphicon-cog settingButton',
    //   onClick: this.onClick,
    //   disabled: dissableEdit,
    // };
    // const deleteButton = {
    //   id: deleteSequence,
    //   className: 'glyphicon glyphicon-trash deleteButton',
    //   onClick: this.onClick,
    //   disabled: dissableEdit,
    // };
    // const saveButton = {
    //   id: saveConfig,
    //   className: 'glyphicon glyphicon-ok saveButton',
    //   onClick: this.onClick,
    //   disabled: dissableEdit,
    // };
    // const discardButton = {
    //   id: discardConfig,
    //   className: 'glyphicon glyphicon-remove discardButton',
    //   onClick: this.onClick,
    //   disabled: dissableEdit,
    // };
    const runTimeMode = [
      {
        label: RUN_TIME_MODE.TIMES.NAME,
        value: RUN_TIME_MODE.TIMES.VALUE,
        disabled: isSequenceDesignerRunning,
      },
      {
        label: RUN_TIME_MODE.MINUTES.NAME,
        value: RUN_TIME_MODE.MINUTES.VALUE,
        disabled: isSequenceDesignerRunning,
      },
    ];
    // const firstButton = isConfigView === true ? saveButton : settingButton;
    // const secondButton = isConfigView === true ? discardButton : deleteButton;
    const borderSequenceStyle = isConfigView === true ? '' : 'borderSequence';
    return (
      <div className={`${borderSequenceStyle} cycleParent center${isRunning}`}>
        <div className="col-md-1 removePadding center">
          {!dissableEdit && <DragHandle disabled={dissableEdit} />}
          {dissableEdit && <span className="grippy disabledGrippy" />}
        </div>
        <div className="col-md-1 removePadding center">
          <Switch
            onChange={this.handleChangeSequenceState}
            checked={sequence.Active}
            id="normal-switch"
            disabled={dissableEdit}
            height={32}
            width={64}
            uncheckedIcon=""
            checkedIcon=""
            onColor="#006AF5"
            offColor="#A8A8A8"
          />
        </div>
        <div className="col-md-3 removePadding center ">
          <div className="select-box-parent">
            <input
              id={APPDATA.SEQUENCE}
              className="selectBoxField"
              readOnly
              onClick={this.onClick}
              value={this.sequenceNameConverter(sequence.Sequence)}
              disabled={dissableEdit}
            />
          </div>
        </div>
        <div className="col-md-1 removePadding center">
          <div className="total-sequence-parent">
            <input
              className="totalSequenceField"
              id={repeat}
              readOnly
              value={repeatValue}
              onClick={this.updateRepeatSequence}
              disabled={dissableEdit}
            />
          </div>
        </div>
        <div className="col-md-4 removePadding center">
          <div className="run-time-mode center">
            <ToggleButtonCustom
              buttonProp={runTimeMode}
              defaultValue={RUN_TIME_MODE.TIMES.VALUE}
              value={sequence.RepeatType}
              onClick={this.handleChangeRepeatMode}
              disabled={dissableEdit}
            />
          </div>
        </div>
        <div className="col-md-1 removePadding center" />
        <div className="col-md-1 removePadding center" />
      </div>
    );
  }
}
export default CycleSetting;
